module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-43585ae20896bfdca6442507c508614e.webp";